import { updateNotificationsRoute } from "@slfinrtl/ui-bff-routes"
import { useCallback, useState } from "react"
import { useBffDynamic } from "src/hooks"

export const useUpdateNotification = () => {
	const updateNotificationsRequest = useBffDynamic(updateNotificationsRoute, "inline")
	const [pendingIds, setPendingIds] = useState<Set<string>>(() => new Set())

	const updateNotification = useCallback(
		async (userNotificationId: string, status: "SEEN" | "READ"): Promise<void> => {
			setPendingIds((prev) => new Set(prev).add(userNotificationId))

			try {
				await updateNotificationsRequest({
					body: { ids: [userNotificationId], status },
					pathParams: {},
					queryParams: {},
				})
			} finally {
				setPendingIds((prev) => {
					const next = new Set(prev)
					next.delete(userNotificationId)
					return next
				})
			}
		},
		[updateNotificationsRequest],
	)

	const isPending = useCallback((userNotificationId: string) => pendingIds.has(userNotificationId), [pendingIds])

	return {
		isPending,
		updateNotification,
	}
}
